
import siteService from "@services/siteService.js";
import googleService from "@services/googleService.js";
import embedCodeService from "@services/embedCodeService.js";
import productWebsiteService from "@services/productWebsiteService.js";
import * as jsonpatch from 'fast-json-patch';
import { loadI18nLanguageAsync } from '@i18n';
import pageContentStatic from '@model/components/pageContentStatic.model';
import pageContentItemStatic from '@model/components/pageContentItemStatic.model';
import pageAlbumItemStatic from '@model/components/pageAlbumItemStatic.model';
import pageAlbumStatic from '@model/components/pageAlbumStatic.model';
import pageProductStatic from '@model/components/pageProductStatic.model';
import pageProductItemStatic from '@model/components/pageProductItemStatic.model';
import pageEventCalendarItemStatic from '@model/components/pageEventCalendarItemStatic.model';

const state = {
  config: {
    manageUrl: "",
    languages: {},
  },
  screen: {
    languages: {},
    domain: {},
    eventCalendar: {},
  },
  currencyMain: undefined,
  currencyUse: undefined,
  currencyDisplay: undefined,
  currenciesConverter: [],
  multiplier: 1,
  productBadges: [],
  customFonts: [],
  productButtonContactSetting: undefined,
  isExamplePage: false,
  shopSettings: undefined,
  limit: {
    section: null,
    slideSection: null, // ------ Include in section ------ Ex: section limit: 5, slide section limit: 1 MEAN: other section 4 + slide section 1 = 5 section
    grid: null,
    slidePage: null,
    packageID: 6,
  },
  productReviewConfig: {},
}

const getters = {
  sections: state => {
    return state.screen.sections
  },
  languages: state => {
    return state.config.languages
  },
  domain: state => {
    return state.screen.domain
  },
  currencies: state => {
    return state.config.currencies
  },
  services: state => {
    return state.config.services
  },
  currencyMain: state => {
    return state.currencyMain
  },
  currencyUse: state => {
    return state.currencyUse
  },
  currencyDisplay: state => {
    return state.currencyDisplay
  },
  currenciesConverter: state => {
    return state.currenciesConverter
  },
  isEnableAutoConverter: state => {
    return state.config.currencies.isEnableAutoConverter
  },
  multiplier: state => {
    return state.multiplier
  },
  productBadges: state => {
    return state.productBadges
  },
  customFonts: state => {
    return state.customFonts
  },
  productButtonContactSetting: state => {
    return state.productButtonContactSetting
  },
  isExamplePage: state => {
    return state.isExamplePage
  },
  shopSettings: state => {
    return state.shopSettings;
  },
  limit: state => {
    return state.limit
  },
  eventCalendar: state => {
    return state.screen.eventCalendar
  },
  productReviewConfig: state => {
    return state.productReviewConfig
  },
}
const actions = {
  initUrl({ dispatch, rootState }, { hash }) {
    dispatch("designIframe/frame/resetFrame", {}, { root: true });
    const arr = hash.replace('#/', '').replace('#', '').split('/')
    let  metaDataID = (arr[0] == 'page') ? arr[1] : undefined
    let elementID = arr[3] || undefined;
    if (!metaDataID) {
      // setDefault
      dispatch('getPage', {})
    } else {      
      // static page refresh don't know current lang.
      const lang = Object.entries(state.config.languages).filter((arr) => arr[1].pages.findIndex(item => item.metaDataID == metaDataID) > -1)[0] && Object.entries(state.config.languages).filter((arr) => arr[1].pages.findIndex(item => item.metaDataID == metaDataID) > -1)[0][0] || rootState.designIframe.metadata.language     

      dispatch("design/site/setLanguageUse", {
        language: lang,
      }, { root: true });
      dispatch("initLanguage", {
        language: lang,
      });
      
      switch (metaDataID) {
        case 'blog':
        case 'post':
        case 'album_item':
        case 'album_list':
        case 'product_list':
        case 'product_item':
        case 'event_calendar_item':
          dispatch('getPageStatic', { metaDataID, lang });
          dispatch("setIsExamplePage", true)
          dispatch("designIframe/postToParent", {
            func: "page/setIsExamplePage",
            payload: true,
          }, { root: true })
          break;
      
        default:
          dispatch('getPage', { metaDataID, lang, elementID});
          dispatch("setIsExamplePage", false)
          break;
      }
    }

  },

  initSiteConfig({ commit, dispatch }, { languages, currencies, services, domain, product, post, blog , album, albumCategory, websitePermissions, eventCalendar, productReviewConfig, statVisitorCount }) {
    commit('SET_SITECONFIG', { languages, currencies, services , product, post, blog , album, albumCategory,websitePermissions, eventCalendar })
    commit('SET_DOMAIN', { domain })
    commit('SET_EVENT_CALENDAR', { eventCalendar })
    commit('SET_PRODUCT_REVIEW_CONFIG', { productReviewConfig })

    dispatch("designIframe/postToParent", {
      func: "page/initSiteConfig",
      payload: {
        languages, currencies, services, domain , product, post, blog , album, albumCategory, websitePermissions, eventCalendar, productReviewConfig, statVisitorCount
      },
    }, { root: true })
  },
  initMainMetadata({ commit, dispatch }, { props, assets }) {
    commit('designIframe/metadata/SET_MATADATA_MAIN', { props, assets }, { root: true })
    dispatch("designIframe/postToParent", {
      func: "page/initMainMetadata",
      payload: { props, assets },
    }, { root: true })
  },
  initSiteMetadata({ commit, dispatch }, { assets, props }) {
    commit('designIframe/metadata/SET_METADATA_SITE', { assets, props }, { root: true })
    dispatch("designIframe/postToParent", {
      func: "page/initSiteMetadata",
      payload: { assets, props },
    }, { root: true })
  },
  async initGoogleMap({ commit, rootState }, ) {
    if(rootState.designIframe.metadata && rootState.designIframe.snapshot.metadataObserver) {
      jsonpatch.unobserve(rootState.designIframe.metadata, rootState.designIframe.snapshot.metadataObserver)
    }
    const gmap = await googleService.getGoogleMap();
    const key = gmap.googleMapKey && gmap.isOpenMap ? gmap.googleMapKey : process.env.VUE_APP_EDITOR_RENDER_GOOGLE_MAP_KEY
    let gmapObj = Object.keys(gmap).length > 0 ? gmap : {
      mapKeyID: "default",
      googleMapKey: process.env.VUE_APP_EDITOR_RENDER_GOOGLE_MAP_KEY,
      isOpenMap: true
    }
    commit('designIframe/metadata/SET_GOOGLEMAP', { key, gmapObj }, { root: true })
    if(rootState.designIframe.snapshot.metadataObserver &&  rootState.designIframe.metadata) {
      rootState.designIframe.snapshot.metadataObserver = jsonpatch.observe(rootState.designIframe.metadata);
    }
  },
  async initEmbedCode({ commit }, ) {
    const embedCode = await embedCodeService.getEmbedCodes();
    commit('designIframe/metadata/SET_EMBEDCODE', { embedCode }, { root: true })
  },
  async setImagesID({ commit }, { imagesID }) {
    await commit('designIframe/siteData/SET_IMAGES_ID', { imagesID }, { root: true })
  },
  initSitePage({ commit, dispatch }, { assets, props }) {
    commit('designIframe/metadata/SET_METADATA_PAGE', { assets, props }, { root: true })
    dispatch("designIframe/postToParent", {
      func: "page/initSitePage",
      payload: {
        assets, props
      },
    }, { root: true })
  },
  initLimit({ commit, dispatch }, { limit }) {
    commit('SET_LIMIT', { limit })
    dispatch("designIframe/postToParent", {
      func: "page/initLimit",
      payload: {
        limit
      },
    }, { root: true })
  },
  getPage: async ({ dispatch, commit, rootState }, { metaDataID, lang, elementID = '' }) => {
    dispatch("designIframe/frame/resetFrame", {}, { root: true });     // เมศ แก้ไขชั่วคราว
    if (rootState.designIframe.snapshot.metadataObserver) {
      jsonpatch.unobserve(rootState.designIframe.metadata, rootState.designIframe.snapshot.metadataObserver)
    }
    const language = lang || rootState.designIframe.metadata.language
    await dispatch("getSiteMetadata", { lang });
    let metadataid = metaDataID
    let pageID = '';
    let pageName = '';

    if (!metaDataID) {
      pageID = rootState.designIframe.metadata.screen.SITE.assets.components.MAIN_PAGE.properties.pageID
      pageName = rootState.designIframe.metadata.screen.SITE.assets.components[pageID].properties.name
      metadataid = metaDataID || rootState.designIframe.metadata.screen.SITE.assets.components[pageID].properties.metaDataID
      commit('designIframe/metadata/SET_ACTIVE_PAGE', { metadataid, pageID, pageName }, { root: true })
    }

    let sitePage = await siteService.getSitePage({ lang: language, id: metadataid })
    if (metaDataID && sitePage.version) {
      pageID = sitePage.props.id || rootState.designIframe.metadata.screen.SITE.assets.components.MAIN_PAGE.properties.pageID;
      pageName = rootState.designIframe.metadata.screen.SITE.assets.components[pageID].properties.name;
      commit('designIframe/metadata/SET_ACTIVE_PAGE', { metadataid, pageID, pageName, elementID }, { root: true });
    }else {
      pageID = rootState.designIframe.metadata.screen.SITE.assets.components.MAIN_PAGE.properties.pageID
      pageName = rootState.designIframe.metadata.screen.SITE.assets.components[pageID].properties.name
      metadataid = rootState.designIframe.metadata.screen.SITE.assets.components[pageID].properties.metaDataID
      commit('designIframe/metadata/SET_ACTIVE_PAGE', { metadataid, pageID, pageName }, { root: true })
      sitePage = await siteService.getSitePage({ lang: language, id: metadataid })
    }
    dispatch('initSitePage', sitePage)
    dispatch('designIframe/postToParent', {
      func: "page/setPage",
      payload: { metaDataID: metadataid, pageID, pageName, elementID },
    }, { root: true })
    rootState.designIframe.snapshot.metadataObserver = jsonpatch.observe(rootState.designIframe.metadata);
    dispatch('designIframe/original/setOriginalObserver', JSON.parse(JSON.stringify(rootState.designIframe.snapshot.metadataObserver)) , { root: true })
    if (elementID) {
      dispatch(
        "designIframe/postToParent",
        {
          func: "component/scrollToId",
          payload: { elementID: elementID, block: "start", behavior: "smooth" },
        },
        { root: true }
      );
    }else {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
    commit('SET_IS_EXAMPLE_PAGE', false);
  },
  getPageStatic: async ({ dispatch, commit, rootState }, { metaDataID, lang }) => {
    dispatch("designIframe/frame/resetFrame", {}, { root: true });     // เมศ แก้ไขชั่วคราว
    if (rootState.designIframe.snapshot.metadataObserver) {
      jsonpatch.unobserve(rootState.designIframe.metadata, rootState.designIframe.snapshot.metadataObserver)
    }
    const language = lang || rootState.designIframe.metadata.language
    await dispatch("getSiteMetadata", { lang : language });
    let metadataid = metaDataID
    let pageID = '';
    let pageName = '';
    let sitePage = '';
    // get Json here
    switch (metadataid) {
      case 'blog':
        pageID = 'blog';
        pageName = 'Blog';
        sitePage = pageContentStatic.schemas[1];
        break;
      case 'post':
        pageID = 'post';
        pageName = 'Post';
        sitePage = pageContentItemStatic.schemas[1];
        break;
      case 'album_item':
        pageID = 'album_item';
        pageName = 'Photo';
        sitePage = pageAlbumItemStatic.schemas[1];
        break;
      case 'album_list':
        pageID = 'album_list';
        pageName = 'Photo Album';
        sitePage = pageAlbumStatic.schemas[1];
        break;
      case 'product_list':
        pageID = 'product_list';
        pageName = 'All Product';
        sitePage = pageProductStatic.schemas[1];
        break;
      case 'product_item':
        pageID = 'product_item';
        pageName = 'Product Detail';
        sitePage = pageProductItemStatic.schemas[1];
        break;
      case 'event_calendar_item':
        pageID = 'event_calendar_item';
        pageName = 'Event Calendar Detail';
        sitePage = pageEventCalendarItemStatic.schemas[1];
        break;
      default:
        dispatch('getPage');
        break;
    }
    commit('designIframe/metadata/SET_ACTIVE_PAGE', { metadataid, pageID, pageName, elementID: "example" }, { root: true});
    dispatch('initSitePage', sitePage);
    dispatch('designIframe/postToParent', {
      func: "page/setPage",
      payload: { metaDataID: metadataid, pageID, pageName, elementID: "example" },
    }, { root: true })
    rootState.designIframe.snapshot.metadataObserver = jsonpatch.observe(rootState.designIframe.metadata);
    dispatch('designIframe/original/setOriginalObserver', JSON.parse(JSON.stringify(rootState.designIframe.snapshot.metadataObserver)) , { root: true })
    commit('SET_IS_EXAMPLE_PAGE', true);
  },
  getSiteMetadata: async ({ dispatch, rootState }, { lang }) => {
    const language = lang || rootState.designIframe.metadata.language
    const siteMetadata = await siteService.getSiteMetadata({ lang: language })
    dispatch('initSiteMetadata', siteMetadata)
  },
  getSiteConfig: async ({ dispatch }) => {
    const siteConfig = await siteService.getSiteConfig()
    dispatch('initSiteConfig', siteConfig)

    const language = Object.entries(siteConfig.languages).filter((arr) => arr[1].isDefault)[0][0]
    const currencies =  siteConfig.currencies;
    const websitePermissions = siteConfig.websitePermission;
    const customFonts = siteConfig.customFonts;
    console.log('websitePermissions', websitePermissions);
    dispatch('initLanguage', { language })
    dispatch('initCurrency', { currencies })
    dispatch('initCustomFonts', { customFonts })
    dispatch('initPermission',websitePermissions)

    const productBadges = await productWebsiteService.getBadges(language);
    dispatch('initProductBadges', productBadges);

    const productButtonContactSetting = await productWebsiteService.getProductButtonContactSetting();
    dispatch('initProductButtonContactSetting', productButtonContactSetting);
  },
  initAppearance: async ({ dispatch }) => {
    const siteAppearance = await siteService.getSiteTheme()
    dispatch('initMainMetadata', siteAppearance)
  },
  initialiseDesignData: async ({ dispatch, commit }, { preview }) => {
    commit('designIframe/SET_PREVIEW', { preview }, { root: true })
    const siteConfig = await siteService.getSiteConfig()
    const siteAppearance = await siteService.getSiteTheme()
    const limit = siteConfig.limit
    dispatch('initSiteConfig', siteConfig)
    dispatch('initMainMetadata', siteAppearance)
    dispatch('initGoogleMap')
    dispatch('initEmbedCode')
    const language = Object.entries(siteConfig.languages).filter((arr) => arr[1].isDefault)[0][0]
    const currencies =  siteConfig.currencies;
    const websitePermissions = siteConfig.websitePermission;
    const customFonts = siteConfig.customFonts;
    const shopSettings = siteConfig.shopSettings;
    dispatch('initLanguage', { language })
    dispatch('initCurrency', { currencies })
    dispatch('initCustomFonts', { customFonts })
    dispatch('initPermission',websitePermissions)
    dispatch('setShopSettings', shopSettings)

    dispatch('initLimit', { limit })
    dispatch("designIframe/postToParent", {
      func: "callFromChildren",
      payload: { txt: 'ping' },
    }, { root: true })


    const productBadges = await productWebsiteService.getBadges(language);
    dispatch('initProductBadges', productBadges);

    const productButtonContactSetting = await productWebsiteService.getProductButtonContactSetting();
    dispatch('initProductButtonContactSetting', productButtonContactSetting);
  },
  initPermission({dispatch},websitePermissions) {
    dispatch("designIframe/permissionWebsite/setPermissionWebsite", { websitePermissions }, { root: true });
    dispatch("designIframe/postToParent", {
      func: "permissionWebsite/setPermissionWebsite",
      payload: {
        websitePermissions
      },
    }, { root: true })
  },
  initLanguage({ commit, dispatch }, { language }) {
    commit('designIframe/metadata/SET_ACTIVE_LANGUAGE', { language }, { root: true })

    loadI18nLanguageAsync(language);

    dispatch("designIframe/postToParent", {
      func: "page/initLanguage",
      payload: {
        language
      },
    }, { root: true })
  },
  initCurrency({ commit, dispatch }, { currencies }) {
    const currencyMain = currencies.data.find((item) => item.isMain).code;
    const currencyUse =currencies.data.find((item) => item.isMain).code;
    const currenciesConverter = currencies.data.reduce(
        (obj, item) => ({
          ...obj,
          [item.code]: item,
        }),
        {}
      );

    commit('SET_CURRENCY_MAIN', currencyMain );
    commit('SET_CURRENCY_USE', currencyUse );
    commit('SET_CURRENCIES_CONVERTER', currenciesConverter );

    dispatch('setMultiplier');
    dispatch('setCurrencyDisplay');
  },
  setCurrencyUse({ dispatch, commit }, currencyUse ) {
    commit('SET_CURRENCY_USE', currencyUse );
    dispatch('setCurrencyDisplay');
    dispatch('setMultiplier');
  },
  setCurrencyDisplay({ commit, state }) {
    const currencyDisplayType = state.config.currencies.currencyDisplay;
    let currencyDisplay = undefined;
    if (currencyDisplayType === 'symbol') {
      currencyDisplay = state.currenciesConverter[state.currencyUse].symbol;
    } else {
      currencyDisplay = state.currenciesConverter[state.currencyUse].code;
    }

    commit('SET_CURRENCY_DISPLAY', currencyDisplay );
  },
  setMultiplier: async ({ commit, state })  => {
    const multiplier = state.currenciesConverter[state.currencyUse].multiplier;
    commit('SET_MULTIPLIER', multiplier );
  },
  initProductBadges({ commit }, productBadges) {
    commit('SET_PRODUCT_BADGES', productBadges );
  },
  initCustomFonts({ commit }, { customFonts }) {
    commit('SET_CUSTOM_FONTS', customFonts );
  },
  initProductButtonContactSetting({ commit }, productButtonContactSetting) {
    commit('SET_PRODUCT_BUTTON_CONTACT_SETTING', productButtonContactSetting );
  },
  setIsExamplePage({ commit }, isExamplePage) {
    commit('SET_IS_EXAMPLE_PAGE', isExamplePage)
  },
  setShopSettings({ commit }, shopSettings) {
    commit('SET_SHOP_SETTINGS', shopSettings );
  },
  initStatVisitorCount({ commit }, { statVisitorCount }) {
    commit('designIframe/siteData/SET_STAT_VISITOR_COUNT', { statVisitorCount }, { root: true })
  },
}
const mutations = {
  SET_SITECONFIG(state, config) {
    state.config = config
  },
  SET_CURRENCY_MAIN(state, currency) {
    state.currencyMain = currency
  },
  SET_CURRENCY_USE(state, currency) {
    state.currencyUse = currency
  },
  SET_CURRENCY_DISPLAY(state, currencyDisplay) {
    state.currencyDisplay = currencyDisplay
  },
  SET_CURRENCIES_CONVERTER(state, currenciesConverter) {
    state.currenciesConverter = currenciesConverter
  },
  SET_MULTIPLIER(state, multiplier ) {
    state.multiplier = multiplier
  },
  SET_PRODUCT_BADGES(state, productBadges ) {
    state.productBadges = productBadges
  },
  SET_CUSTOM_FONTS(state, customFonts ) {
    state.customFonts = customFonts
  },
  SET_PRODUCT_BUTTON_CONTACT_SETTING(state, productButtonContactSetting ) {
    state.productButtonContactSetting = productButtonContactSetting
  },
  SET_DOMAIN(state, { domain }) {
    state.screen.domain = domain
  },
  SET_IS_EXAMPLE_PAGE(state, isExamplePage) {
    state.isExamplePage = isExamplePage
  },
  SET_SHOP_SETTINGS(state, shopSettings) {
    state.shopSettings = shopSettings
  },
  SET_LIMIT(state, { limit }) {
    state.limit = limit
  },
  SET_EVENT_CALENDAR(state, { eventCalendar }) {
    state.screen.eventCalendar = eventCalendar
  },
  SET_PRODUCT_REVIEW_CONFIG(state, { productReviewConfig }) {
    state.productReviewConfig = productReviewConfig;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};